module.exports = {
      id: "logging-usage",
      viewBox: "0 0 683 683",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#logging-usage",
      toString: function () {
        return this.url;
      }
    }